module.exports = __webpack_public_path__ + "static/media/2.463d448e.jpg";